import {reportState} from "../apiCaller";
import {v4 as uuidv4} from 'uuid';
import {store} from "./../store";
const dayjs = require('dayjs')


function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}


function msgHandler(payload) {
    try {
        payload = JSON.parse(payload)
    } catch (e) {
        console.log(e)
        console.log(payload)
        return
    }

    let slices = payload.action.split("/")
    if (payload.action === "response/heartBeat") {
        return
    }

    if (payload.action === "reload") {
        window.location.reload()
    }

    switch (slices[0]) {
        case "response":
            var responseId = slices[1]
            if (pendingResponses.hasOwnProperty(responseId)) {
                pendingResponses[responseId](payload["payload"])
            }
            break;
        case "scans":
            switch(slices[1]){
                case "update":
                    console.log(payload.payload.visitors)
                    store.dispatch({"type": "scans/update", "payload": payload.payload.visitors})
                    break;
            }
            break;
        case "company":
            switch(slices[1]){
                case "updateLogo":
                    store.dispatch({"type": "company/updateLogo", "payload": makeid(5)})
                    break;
            }
            break;
        case "leaderboard":
            switch(slices[1]){
                case "updateRank":
                    store.dispatch({"type": "leaderboard/updateRank", "payload": payload.payload})
                    break;
            }
            break;
        case "location":
            switch(slices[1]){
                case "update":
                    store.dispatch({"type": "location/update", "payload": payload.payload})
            }
            break;
        case "state":
            switch(slices[1]){
                case "report":
                    reportState(() => {}, store.getState().scans)
            }
        default:
            console.log(payload)
            break;
    }
}

var socket = undefined
var end = false

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

var deviceToken = getCookie("token")

var sockets = {}

async function websocketManager(){

    end = false
    var uri = document.getElementById("host").value

    var devToken = document.getElementById("devtoken")

    if(devToken === undefined){

        fetch("/api/config/getToken")
            .then((response) => response.text())
            .then((token) => {
                var element = document.createElement("input")
                element.type = "hidden"
                element.value = token
                element.id = "devtoken"
                document.body.appendChild(element)
            })
        }


    socket = new WebSocket("wss://"+ uri + `/api/devices/` + document.getElementById("devtoken").value + `/ws`)
    var socketID = uuidv4()

    socket.addEventListener("open", (event) => {
        console.log("ws opened")
        sockets[socketID] = "open"
        store.dispatch({"type": "wsToken", "payload": socketID})
    });

    // Listen for messages
    socket.addEventListener("message", (event) => {
        msgHandler(event.data)
        //console.log(event.data)

    });

    socket.addEventListener("close", async (event) => {
        end = true
        sockets[socketID] = "closed"
        await new Promise(r => setTimeout(r, 3000));
        websocketManager();
        console.log("socket closed");
        if(store.getState().location.ID === 0){

            store.dispatch({"type": "location/update", "payload": {ID: getCookie("locationid"), name: getCookie("locationname")}})
            store.dispatch({"type": "scans/update", "payload": getCookie("scans")})
            store.dispatch({"type": "leaderboard/updateRank", "payload": getCookie("rank")})


        }

    })
    let heartBeat = JSON.stringify({"action": "heartBeat", "payload": "", "response": "heartBeatResponse"})
    var errorCount = 0

    while(true){

        if(end){
            console.log("killing heart beat")
        }
        if(sockets[socketID] === "closed"){
            break
        }
        if(end === false){
            if(socket.readyState === WebSocket.OPEN){
                socket.send(heartBeat)
                errorCount = 0
            }
        }else{
            break
        }

        await new Promise(r => setTimeout(r, 1000));
    }
}

const waitForSocketOpen = (socket, timeout = 5000) => {
    if(store.getState().location.ID === 0){

        store.dispatch({"type": "location/update", "payload": {ID: getCookie("locationid"), name: getCookie("locationname"), multiLocation: false}})
        store.dispatch({"type": "scans/update", "payload": getCookie("scans")})
        store.dispatch({"type": "leaderboard/updateRank", "payload": getCookie("rank")})


    }
    return new Promise((resolve, reject) => {
        // If the socket is already open, resolve immediately.
        if (socket.readyState === WebSocket.OPEN) {
            resolve();
        } else {
            // Attach event listeners to resolve the promise when the socket opens.
            const onOpen = () => {
                clearTimeout(timeoutId);
                socket.removeEventListener('open', onOpen);
                resolve();
            };

            // Set up a timeout to reject the promise if the socket doesn't open in time.
            const timeoutId = setTimeout(() => {
                socket.removeEventListener('open', onOpen);
                reject(new Error('WebSocket connection timeout'));
            }, timeout);

            socket.addEventListener('open', onOpen);
        }
    });
};

var pendingResponses = {}


export const sendWsMessage = async (payload, responseId, response) => {
    pendingResponses[responseId] = response
    try {
        await waitForSocketOpen(socket);

        socket.send(payload);
    } catch (error) {
        console.error("Failed to send message:", error.message);
    }
};

export const startWsManager = (userToken) => {
    websocketManager()
}
function sleep(ms){
    return new Promise(resolve => setTimeout(resolve, ms));
}
async function waitToStartManager() {
    sleep(2000)
    startWsManager()
}


waitToStartManager()